import State from '../State';
import CustomerUpdatedSucceed from '../events/CustomerUpdatedSucceed';
import Customer from '../../../domain/Customer';

export default (state: State, event: CustomerUpdatedSucceed): State => ({
    ...state,
    customers: state.customers.map(
        (client: Customer): Customer => {
            if (client.customerId === event.customerId) {
                return {
                    ...client,
                    ...event.user
                };
            } else {
                return client;
            }
        }
    )
});



// WEBPACK FOOTER //
// ./src/application/admin/reducer/updateCustomerSucceed.ts